import React from 'react';
import styled from 'styled-components';

const ProgressBar = props => {
  const { p } = props;

  return (
    <Wrapper>
      <Back />
      {!!p && !isNaN(p) && <Fore p={p} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 6px;
  width: 100%;
  margin-top: 8px;
`;

const Back = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  background-color: #c6e4f2;
`;

const Fore = styled(Back)`
  width: ${props => props.p}%;
  // background-color: ${props => (props.p === 100 ? 'green' : '#427aaf')};
  background-color: #427aaf;

  transition: all 0.2s ease-out;
`;

export default ProgressBar;
